import { ActionsUnion, ICoordinates, IOperatorLocation, IMapBound, IOSMDirectionReq } from '../../../types/'
import * as constants from '../../constants'
import { createAction } from '../helpers'
import { IStoreState, IGetGoogleMapPolyline, IGoinZoneObject, IMarker, IActiveTripResponseV2 } from '../../../types'
import { googleMapService } from '../../../services/GoogleMap'
import { IGetDirectionsResponseDTO, IGoogleMapBoundsDTO } from '../../../types/google-map'
import { savePolylineBounds, actionCreators as tripsActionCreators } from '../trips'
import TripAccepted from 'src/components/trips/trip-detail/TripAccepted'
import { osmService } from 'src/services/OSMService'

export const actionCreators = {
  //Sync action creators
  setOrigin: (coordinates: ICoordinates | null) => createAction(constants.SET_ORIGIN, coordinates),
  setDestination: (coordinates: ICoordinates | null) => createAction(constants.SET_DESTINATION, coordinates),
  setAdditionalStop: (coordinates: ICoordinates | null) => createAction(constants.SET_ADDITIONAL_STOP, coordinates),
  removeAdditionalStop: (index: number) => createAction(constants.REMOVE_ADDITIONAL_STOP, index),
  setOperatorLocation: (location: IOperatorLocation) => createAction(constants.SET_OPERATOR_LOCATION, location),
  setCenter: (coordinates: ICoordinates) => createAction(constants.SET_CENTER, coordinates),
  setInitCenter: () => createAction(constants.SET_INIT_CENTER),
  setZoom: (zoom: number) => createAction(constants.SET_ZOOM, zoom),
  addMarkers: (type: string, markers: IMarker[]) => createAction(constants.ADD_MARKERS, { type, markers }),
  replaceMarkers: (type: string, markers: IMarker[]) => createAction(constants.REPLACE_MARKERS, { type, markers }),
  removeMarkers: (index: number) => createAction(constants.REMOVE_MARKER, index),
  clearMarkers: (type?: string) => createAction(constants.CLEAR_MARKERS, { type }),
  setPolygon: (polygon: ICoordinates[]) => createAction(constants.SET_POLYGON, polygon),
  setZone: (zoneId: string) => createAction(constants.SET_MAP_ZONE, zoneId),
  setPolyline: (routePolyline: string | null) => createAction(constants.SET_POLYLINE, routePolyline),
  setBounds: (bounds: IMapBound) => createAction(constants.SET_BOUNDS, bounds),
  setMapViewStrategyStage: (stage: string) => createAction(constants.SET_MAP_VIEW_STRATEGY_STAGE, stage),
  swapLocations: () => createAction(constants.TRIP_LOCATION_SWAP),
  updateAdditionalStopSequence: (fromIndex: number, toIndex: number) =>
    createAction(constants.UPDATE_ADDITIONAL_STOP_SEQUENCE, { fromIndex, toIndex }),
  updateLocationSequence: (fromIndex: number, toIndex: number) =>
    createAction(constants.UPDATE_LOCATION_SEQUENCE, { fromIndex, toIndex })
}

export type IGoogleMapsAction = ActionsUnion<typeof actionCreators>

export function showOrgServiceArea() {
  return (dispatch: any, getState: any) => {
    const { setBounds, setCenter } = actionCreators

    const state: IStoreState = getState()
    if (!state || !state.organizations) {
      return
    }

    const currentOrgId = state.organizations.currentOrgId || ''
    const currentOrg = state.organizations.items[currentOrgId]
    if (currentOrg && currentOrg.serviceAreaBounds && currentOrg.serviceAreaBounds.length === 4) {
      const bounds = new window.google.maps.LatLngBounds()
      const p1 = { lat: parseFloat(currentOrg.serviceAreaBounds[0]), lng: parseFloat(currentOrg.serviceAreaBounds[2]) }
      const p2 = { lat: parseFloat(currentOrg.serviceAreaBounds[1]), lng: parseFloat(currentOrg.serviceAreaBounds[3]) }
      bounds.extend(p1)
      bounds.extend(p2)

      dispatch(setCenter(bounds.getCenter()))
      dispatch(setBounds(bounds))
    }
  }
}

export function clearMap() {
  const { clearMarkers, setOrigin, setDestination, setPolyline } = actionCreators
  return (dispatch: any) => {
    return Promise.all([
      dispatch(clearMarkers()),
      dispatch(setPolyline(null)),
      dispatch(setOrigin(null)),
      dispatch(setDestination(null))
    ])
  }
}

export function getOSMDirection(dto: IOSMDirectionReq) {
  const { setBounds, setPolyline } = actionCreators
  return (dispatch: any) => {
    osmService.getDirection(dto).then((data: any) => {
      console.log('OSM: got directions: ', data)
      try {
        const route = data.routes[0]
        dispatch(
          tripsActionCreators.setEstimatesToTripRequest({
            duration: route.summary.duration,
            distance: route.summary.distance
          })
        )
        dispatch(setPolyline(route.geometry))
        // dispatch(setBounds(route.bbox))   needs to enable once actual OSM widget is implemented
      } catch (err) {
        console.log('Processing osm data err: ', err)
      }
    })
  }
}

export function getDirections(dto: IGetGoogleMapPolyline) {
  const { setBounds, setPolyline } = actionCreators
  return (dispatch: any) => {
    googleMapService.getDirections(dto).then(
      (data: any) => {
        console.log('GOOGLE: got directions: ', data)
        const route = data.routes ? data.routes[0] : null
        const leg = route ? route.legs[0] : null
        if (route && route.overview_polyline) {
          console.log('polyline: ', route.overview_polyline)
          dispatch(setPolyline(route.overview_polyline))
        }
        if (route && route.bounds) {
          dispatch(setBounds(route.bounds))
        }
        dispatch(savePolylineBounds())
        if (leg && leg.distance && leg.duration) {
          dispatch(
            tripsActionCreators.setEstimatesToTripRequest({
              duration: Math.round(leg.duration.value),
              distance: Math.round(leg.distance.value)
            })
          )
        }
      },
      (e: string) => console.log(e)
    )
  }
}



// WEBPACK FOOTER //
// ./src/state/actions/google_map/index.ts